import createAxiosInstance from './axiosConfig';
import { PropostaDTO } from '../shared/dto/propostaDTO';
import { FiltroPropostaDTO } from '../shared/dto/filtroPropostaDTO';
import { Cliente } from '../shared/model/Cliente';
import { CalculoResultadoSimulacaoDTO } from '../shared/dto/calculoResultadoSimulacaoDTO';
import { ResultadoSimulacaoPropostaDTO } from '../shared/dto/resultadoSimulacaoPropostaDTO';
import { AcaoPropostaEnum } from '../shared/constantes/acaoPropostaEnum';
import { ReemissaoCcbDTO } from '../shared/dto/reemissaoCcbDTO';

const { REACT_APP_ESTEIRA_BACK } = process.env;

const axiosInstance = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/propostaController');
const axiosPropostaEsteira = createAxiosInstance(REACT_APP_ESTEIRA_BACK + '/rest/validacaoFaseEsteira');

export default class PropostaService {
  axios: any; 

  constructor() {
    this.axios = axiosInstance;
  }

  async listarTodasPropostas(currentPage: number, max: number, dto: FiltroPropostaDTO) {
    return await this.axios.post(`/listarTodasPropostas?page=${currentPage}&max=${max}`, dto);
  };

  async listarPropostasParaLote(currentPage: number, max: number, dto: FiltroPropostaDTO) {
    return await this.axios.post(`/listarPropostasParaLote?page=${currentPage}&max=${max}`, dto);
  };

  async listarPropostaEspelhoJasper(idProposta: number) {
    return await this.axios.get(`/listarPropostaEspelhoJasper?idProposta=${idProposta}`, {
      responseType: 'blob', 
    });
  };

  async listarAtividadesDisponiveis(esteira: number) {
    return await this.axios.post(`/listarAtividadesDisponiveis?esteira=${esteira}`);
  };

  async aprovarReprovarEmLote(acao: AcaoPropostaEnum, motivo: string | null, dto: PropostaDTO[]) {
    
    const acaoParam = acao.toUpperCase();
    const motivoParam = motivo ? `&idMotivo=${motivo}` : '';
    return await this.axios.post(`/aprovarReprovarEmLote?acao=${acaoParam}${motivoParam}`, dto);
  };

  async listarPropostaEFluxoAnteriores(idProposta: string) {
    return await this.axios.get(`/listarPropostaEFluxoAnteriores?idProposta=${idProposta}`);
  };

  async listarPropostaEFluxoAnterioresPorNumeroProposta(numeroProposta: string) {
    return await this.axios.get(`/listarPropostaEFluxoAnterioresPorNumeroProposta`, {
      params: { numeroProposta }
    });
  };

  async obterMargemOnline(codigoExterno: string, empregador: string, promotora: string, loja: string, dto: Cliente, tpProduto: string) {
    return await this.axios.post(`/obterMargemOnline?convenio=${codigoExterno!}&empregador=${empregador!}&promotora=${promotora!}&loja=${loja!}&tpProduto=${tpProduto!}`, dto);
  };

  async simulacaoRMCTotal(dto: CalculoResultadoSimulacaoDTO) {
    return await this.axios.post(`/simulacaoRMCTotal`, dto);
  };

  async resultadoSimulacaoParcela(dto: ResultadoSimulacaoPropostaDTO) {
    return await this.axios.post(`/resultadoSimulacaoParcela`, dto);
  };

  async inclusaoProposta(dto: PropostaDTO) {
    return await this.axios.post(`/inclusaoProposta`, dto);
  };

  async listarPropostaParaReprovacao(idProposta: string) {
    return await this.axios.get(`/listarPropostaParaReprovacao?idProposta=${idProposta}`);
  };

  async listarPropostaParaReprovacaoPorNumeroProposta(numeroProposta: string) {
    return await this.axios.get(`/listarPropostaParaReprovacaoPorNumeroProposta`, {
      params: { numeroProposta }
    });
  };

  async liberarAnalise(idProposta: number): Promise<any> {
    return await this.axios.post(`/liberarAnalise?idProposta=${idProposta}`);
  }

  async bloquearProposta(idProposta: number, idUsuario: number): Promise<void> {
    try {
     
      await this.axios.post(`/bloquear`, { idProposta, idUsuario });
     

    } catch (error: any) {
      console.error('Erro na requisição de bloqueio:', error);
      
      if (error.response && error.response.data && error.response.data.message) {
        throw new Error(error.response.data.message); 
      } else if (error.message) {
        throw new Error(error.message); 
      } else {
        throw new Error('Erro desconhecido ao bloquear a proposta.');
      }
    }
  }

  async atualizarProposta(dto: PropostaDTO) {
    return await this.axios.post(`/atualizarProposta`, dto);
  };

  async atualizarDadosBancarios(dto: PropostaDTO) {
    return await this.axios.post(`/atualizarDadosBancarios`, dto);
  };

  async listarPropostasAnterioresPorCpf(cpf: string, idPropostaAtual: number) {
    return await this.axios.get(`/listarPropostasAnterioresPorCpf?cpf=${cpf}&idPropostaAtual=${idPropostaAtual}`);
  };

  async listarIntegracoesExternasPorProposta(idProposta: number, page: number, size: number) {
    return await this.axios.get(`/listarIntegracoesExternasPorProposta?idProposta=${idProposta}&page=${page}&size=${size}`);
  };
  

  async verificaContratosCompraDivida(idProposta: number, cpf: string, matricula: string) {
    return await this.axios.get(`/verificaContratosCompraDivida?idProposta=${idProposta}&cpf=${cpf}&matricula=${matricula}`);
  }

  async lockProposta(idProposta: string | number) {
    return await axiosPropostaEsteira.post(`/${idProposta}/lock`);
  }

  async heartbeatProposta(idProposta: string | number) {
    return await axiosPropostaEsteira.post(`/${idProposta}/heartbeat`);
  }

  async unlockProposta(idProposta: string | number) {
    return await axiosPropostaEsteira.delete(`/${idProposta}/lock`);
  }

  async reemitirCcb(dto: ReemissaoCcbDTO) {
    return await this.axios.post(`/reemitirCcb`, dto);
  };

  async simularTrocaFidcReemissao(dto: ReemissaoCcbDTO) {
    return await this.axios.post(`/simularTrocaFidcReemissao`, dto);
  };

  async pendenciarReemissaoFidc(idProposta: number, motivo: string) {
    return await this.axios.post(`/pendenciarReemissaoFidc`, { idProposta, motivo });
  };

  unlockPropostaKeepAlive(idProposta: string | number) {
    const url = `${REACT_APP_ESTEIRA_BACK}/rest/validacaoFaseEsteira/${idProposta}/lock`;
    const token = localStorage.getItem('token');

    fetch(url, {
      method: 'DELETE',
      keepalive: true,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}` 
      }
    }).catch(console.error);
  }
}
